import React from "react";
import { useTranslation } from "react-i18next";

import style from "../Home/styles.module.scss";

interface Props {
  screen: string;
}

export default function AdminPlaceholder({ screen }: Props) {
  const { t } = useTranslation();

  return (
    <section className={style.card}>
      <h1 className={`pgm-headline-small ${style.title}`}>{screen}</h1>
      <p className={`pgm-body-large ${style.subtitle}`}>
        {t("translations.admin.placeholder", { screen })}
      </p>
    </section>
  );
}
